"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _actionButton = require("../styles/actionButton");

function ActionButton(a) {
  var b = a.onClick,
      c = a.visible,
      d = a.icon,
      e = a.labelText,
      f = a.className,
      g = a.iconColor,
      h = a.iconSize;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_actionButton.BUTTON, "action-button", f)
  }, c ? _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_actionButton.ICON_CONTAINER)
  }, _react["default"].createElement(_Icon["default"], {
    color: g || "regent",
    onClick: b,
    className: (0, _classnames["default"])(_actionButton.ICON, "action__button__icon"),
    name: d,
    size: h
  }), _react["default"].createElement("p", null, e)) : null);
}

ActionButton.defaultProps = {
  onClick: void 0,
  visible: !0,
  icon: "",
  labelText: ""
};

var _default = (0, _react.memo)(ActionButton);

exports["default"] = _default;